export const RESOLVE_DIFFERENCE = "RESOLVE_DIFFERENCE";
export const PAY_PARTIALLY = "PAY_PARTIALLY";
export const WRITE_OFF_REMAINING = "WRITE_OFF_REMAINING";
